module.exports = __webpack_public_path__ + "img/change-position.6a2bd747.png";